<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-6"><span class="CharOverride-1"><a id="_idTextAnchor000"></a>Contents</span></p>
<p class="TOCFM"><a href="#/97808021495416#_idTextAnchor001">Prologue</a></p>
<p class="TOC"><a href="#/97808021495417#_idTextAnchor002">One</a> – <span class="Character CharOverride-10">西 </span>– WEST</p>
<p class="TOC"><span href="#/97808021495418#_idTextAnchor003" title="Link target outside of Sample">Two</span> – <span class="Character CharOverride-10">南 </span>– SOUTH</p>
<p class="TOC"><span href="#/97808021495419#_idTextAnchor004" title="Link target outside of Sample">Three</span> – <span class="Character CharOverride-10">东 </span>– EAST</p>
<p class="TOC"><span href="#/978080214954110#_idTextAnchor005" title="Link target outside of Sample">Four</span> – <span class="Character CharOverride-10">北 </span>– NORTH</p>
<p class="TOC"><span href="#/978080214954111#_idTextAnchor006" title="Link target outside of Sample">Five</span> – <span class="Character CharOverride-10">下 </span>– DOWN</p>
<p class="TOC"><span href="#/978080214954112#_idTextAnchor007" title="Link target outside of Sample">Six</span> – <span class="Character CharOverride-10">上 </span>– UP</p>
<p class="TOC"><span href="#/978080214954113#_idTextAnchor008" title="Link target outside of Sample">Seven</span> – <span class="Character CharOverride-10">左 </span>– LEFT</p>
<p class="TOC"><span href="#/978080214954114#_idTextAnchor009" title="Link target outside of Sample">Eight</span> – <span class="Character CharOverride-10">右 </span>– RIGHT</p>
<p class="TOC"><span href="#/978080214954115#_idTextAnchor010" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="TOC"><span href="#/978080214954116#_idTextAnchor011" title="Link target outside of Sample">Notes</span> on Citations</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021495415.vue?0d2c415d